const EDGES = [
  ["start", "knowledge"],
  ["knowledge", "tool"],
  ["knowledge", "branch"],
  ["branch", "human"],
  ["tool", "complete"],
  ["human", "complete"],
];

function rectIn(canvas, node) {
  const c = canvas.getBoundingClientRect();
  const r = node.getBoundingClientRect();
  return {
    left: r.left - c.left,
    top: r.top - c.top,
    right: r.right - c.left,
    bottom: r.bottom - c.top,
    cx: r.left + r.width / 2 - c.left,
    cy: r.top + r.height / 2 - c.top,
    width: r.width,
    height: r.height,
  };
}

function ports(from, to) {
  const dx = to.cx - from.cx;
  const dy = to.cy - from.cy;
  if (Math.abs(dx) >= Math.abs(dy)) {
    const goingRight = dx >= 0;
    return {
      x1: goingRight ? from.right : from.left,
      y1: from.cy,
      x2: goingRight ? to.left : to.right,
      y2: to.cy,
    };
  }
  const goingDown = dy >= 0;
  return {
    x1: from.cx,
    y1: goingDown ? from.bottom : from.top,
    x2: to.cx,
    y2: goingDown ? to.top : to.bottom,
  };
}

function curve({ x1, y1, x2, y2 }) {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const pull = Math.max(28, Math.min(Math.hypot(dx, dy) * 0.42, 90));
  if (Math.abs(dx) >= Math.abs(dy)) {
    const dir = dx >= 0 ? 1 : -1;
    return `M ${x1} ${y1} C ${x1 + pull * dir} ${y1}, ${x2 - pull * dir} ${y2}, ${x2} ${y2}`;
  }
  const dir = dy >= 0 ? 1 : -1;
  return `M ${x1} ${y1} C ${x1} ${y1 + pull * dir}, ${x2} ${y2 - pull * dir}, ${x2} ${y2}`;
}

function draw(canvas) {
  const svg = canvas.querySelector(".flow-edges");
  if (!svg) return;
  const nodes = {};
  canvas.querySelectorAll(".flow-node[data-id]").forEach((node) => {
    nodes[node.dataset.id] = node;
  });
  const { width, height } = canvas.getBoundingClientRect();
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
  svg.querySelectorAll("path.flow-edge").forEach((path) => path.remove());

  EDGES.forEach(([fromId, toId]) => {
    const from = nodes[fromId];
    const to = nodes[toId];
    if (!from || !to) return;
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("class", "flow-edge");
    path.setAttribute("d", curve(ports(rectIn(canvas, from), rectIn(canvas, to))));
    path.setAttribute("marker-end", "url(#flow-arrowhead)");
    svg.appendChild(path);
  });
}

export function initFlowCanvas() {
  const canvases = document.querySelectorAll("[data-flow-canvas]");
  if (!canvases.length) return;

  const redraw = () => canvases.forEach(draw);
  redraw();
  window.addEventListener("resize", redraw);

  if ("ResizeObserver" in window) {
    canvases.forEach((canvas) => new ResizeObserver(redraw).observe(canvas));
  }
}
